import { CalendarClock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PagePlaceHolder } from './PagePlaceHolder';

export function TimePlanningPage() {
	const { t } = useTranslation();
	return (
		<PagePlaceHolder
			title={t('assets.pages.timePlanning.title')}
			description={t('assets.pages.timePlanning.description')}
			Icon={CalendarClock}
		/>
	);
}
